export default {
  appTitle: 'Arcaea - 새로운 차원의 리듬게임',
  appDescription: '당신을 기다리고 있는 잃어버렸던 세계속의 빛과 화음의 아름다운 충돌. 새로운 차원의 리듬게임.',
  hrefLang: 'ko',
  confirm: '확인',
  cancel: '취소',
  hours: '{hours}시간',
  minutes: '{minutes}분',
  seconds: '{seconds}초',
  error: '에러가',
  generalError: '에러가 발생했습니다. 페이지를 새로고침한 후 다시 시도해주세요.',
  potential: 'Potential',
  daysLeft: '{day}일 남음',
  subscribe: '구독하기',
  subscribeCancel: '구독 취소',
  loading: '불러오는 중...',
  search: 'Search...',
  redirecting: '리다이렉트 중입니다.',
  return: '돌아가기',
  returnToArcaeaOnline: 'Arcaea Online으로 돌아가기',
  ok: 'OK',
  save: '저장',
  calculating: '계산중...',
  clearStatsDisclaimer: 'Arcaea Online에 표시되는 스코어는 오프라인 Arcaea에 표시되는 점수와 상이할 수 있습니다.',
  changelog: {
    title: `Arcaea Online 신기능`,
    list: `
    <div>모든 플레이어:</div>
    <ul class="changelog-list">
      <li>프로필 페이지에 악곡 클리어 통계가 추가되었습니다.</li>
      <li>프로필 페이지와 Top 플레이 이력의 배경화면을 변경할 수 있게 되었습니다.</li>
      <li>일부 유럽 국가 플레이어들이 Paypal을 통해 메모리를 구입할 수 있게 되었습니다.</li>
    </ul>
    <div>Arcaea Online 구독자:</div>
    <ul class="changelog-list">
      <li>스코어 데이터에서 악곡을 검색할 수 있게 되었습니다.</li>
      <li>스코어 데이터에서 "이론치 미만" 순으로 악곡을 정렬할 수 있게 되었습니다.</li>
      <li>Potential 페이지에서 PURE, FAR, LOST 개수를 열람할 수 있게 되었습니다.</li>
      <li>스코어 데이터와 Potential 페이지에서 스코어 획득 일자를 열람할 수 있게 되었습니다.</li>
      <li>역대 Potential 기록 그래프에 "3년", "5년" 옵션이 추가되었습니다.  </li>
    </ul>`
  },
  menu: {
    songRanking: '곡 순위',
    story: '스토리',
    goods: '굿즈',
    login: '로그인',
    account: '마이페이지'
  },
  footer: {
    copyright: '© 2023 lowiro',
    contact: '문의',
    terms: '서비스 이용약관',
    derivativeWorks: '2차적저작물작성권',
    privacyPolicy: '개인정보 처리방침',
    streamingGuidelines: '스트리밍 안내'
  },
  homepage: {
    artist: '작곡가',
    artwork: '아트웍',
    songDescription: '아르케아에서 플레이 가능한 곡 중 무작위 선택'
  },
  account: {
    login: '로그인',
    logout: '로그아웃',
    errorLogin: '로그인 실패. 입력정보를 확인하세요.',
    username: '유저네임',
    checking: '확인 진행중...',
    changeUsername: '이름 변경',
    nameUnavailable: '이 이름은 사용할수 없습니다. 다른 이름을 사용해주세요.',
    nameInvalid: '닉네임은 특수문자를 제외한 3-15자여야 합니다',
    email: '이메일',
    changeEmail: '메일주소 변경',
    errorEmailUnavailable: '이미 사용중인 이메일입니다.<br/>다른 이메일 주소를 사용 바랍니다.',
    memories: '메모리',
    passwordReset: '패스워드 재설정',
    enterEmail: '등록 시 사용한 이메일 주소를 입력해주세요',
    submit: '확인',
    usernameEmailID: '유저네임, 이메일 혹은 ID',
    forgotPassword: '암호를 잊으셨나요?',
    errorInvalidEmail: '유효한 이메일 주소가 아닙니다',
    errorUnknownEmail: '입력하신 이메일 주소는 존재하지 등록되어있지 않습니다',
    requestForgotSuccess: '지정된 주소로 패스워드 재설정 이메일을 보냈습니다. 메일 수신함을 확인해주세요.',
    newPassword: '새로운 패스워드를 입력하세요',
    newPasswordConfirm: '새로운 패스워드 (확인)',
    passwordResetInput: '새로운 패스워드',
    passwordResetConfirm: '새로운 패스워드 (확인)',
    passwordResetSuccess: '패스워드가 변경되었습니다',
    errorMismatchPassword: '새롭게 적은 패스워드가 서로 일치하지 않습니다',
    errorInvalidPassword: '패스워드는 8자 이상이어야 합니다',
    errorInvalidResetToken: '링크가 만료되었습니다. 새로운 초기화 링크를 요청하십시오.',
    password: '암호',
    loginCaps: '로그인',
    creditCard: '카드 / 그 외',
    purchaseMemories: '메모리 구매하기',
    nameChangeWarn: '<span class="bold highlight-color">{amount} 메모리</span> 를 사용하여 이름을 <br/>변경하시겠습니까?',
    payUsing: '결제 방법',
    proccessingPayment: '처리 중...',
    purchase: '결제하기',
    purchaseFailed: '구매 실패',
    purchaseFailedDescription: '결제가 실패하였습니다.<br/>재시도해 주십시오.',
    purchaseComplete: '결제 완료',
    justAdded: '{amount} 메모리 구매를 완료하였습니다.',
    thankYou: '구매해 주셔서 감사합니다!',
    Account: '계정',
    backToAccount: '마이페이지로 돌아가기',
    currentMemories: '현재 메모리',
    usernameCost: '이름 변경에 <span class="bold">{amount} 메모리</b>가 소모됩니다.',
    change: '변경',
    cancel: '취소',
    newName: '새로운 이름',
    newNameConfirm: '계정 닉네임이 다음과 같이 변경됩니다 : ',
    newEmailConfirm: '계정 이메일이 다음과 같이 변경됩니다 : ',
    newEmail: '새로운 이메일 주소',
    emailChangeWarn: '변경하고자 하는 메일 주소가 맞는지 다시 확인바랍니다 <b>{email}</b>?',
    checkInbox: '인증을 위해 발송된 이메일을 받은 편지함에서 확인 바랍니다.',
    verifyingEmail: '확인중...',
    verifyEmailSuccess: '이메일 주소 변경을 완료하였습니다.',
    errorVerifyEmail: '이메일 주소 변경에 실패, 처음부터 다시 시도 바랍니다.',
    agree: '승인',
    version: '버전{version}',
    deleteUser: '계정 삭제 신청 확인',
    verifyDeleteUserSuccess: '당신의 아르케아 계정이 성공적으로 삭제되었습니다.',
    errorVerifyDeleteUser: '계정 삭제 과정이 실패했습니다. 다시 진행하여 주십시오.',
    verifyingDeleteUser: '확인중...',
    selectYourRegion: '지역을 선택하세요',
    ensureSelectRegion: '온라인으로 메모리 구매를 원할 경우 구매자의 선택 지역이 선택한 결제 방법의 지역과 동일해야 합니다. ',
    selectRegionConfirm: '선택 지역',
    digitalContents: '디지털 콘텐츠',
    manageDigitalOST: '관리/다운로드',
    owned: '보유량: {amount}',
    errorInvalidUserCode: 'ID는 9자리여야 합니다',
    errorAddFriend: '친구 추가 중 오류가 발생했습니다',
  },
  arcaeaOnline: {
    subscribedUntil: '{date}까지 구독되어있습니다',
    benefit1: '스코어 관련 데이터 열람 가능',
    benefit2: '친구의 종합 스코어 랭킹 열람 가능',
    benefit3: 'Potential 관련 데이터 열람 가능',
  },
  scoreData: {
    playsThisYear: '올해 플레이 횟수',
    leaderboards: '리더보드',
    obtained: `스코어 획득 일자`,
    obtainedDate: `스코어 획득 일자: {date}`,
  },
  leaderboard: {
    totalScoreRanking: 'Total Score Ranking',
    world: '전세계',
    friend: '친구',
    top50: 'Top 50',
    myRank: '내 순위',
    lastUpdated: 'Last updated: {date}',
  },
  ptt: {
    topRatedRecentPlays: '최근 Top 플레이',
    top30Plays: 'Top 스코어 30',
    noPlays: '플레이 기록 없음',
    '1W': '1주',
    '1M': '1개월',
    '1Y': '1년',
  },
  friend: {
    addFriend: '친구 추가',
    pleaseEnterPlayerId: '플레이어의 ID를 입력하세요.',
    sendFriendRequest: '친구 추가',
    friendCount: '친구 수 {friendCount}/{maxCount}',
    removeFriendTitle: '친구 삭제',
    removeFriend: '친구 삭제',
    areYouSureRemove: '친구 목록에서 <b>{name}</b>를 삭제하시겠습니까?',
    friendList: '친구 목록',
    maxIncreaseInGame: '최대 친구수는 Arcaea 앱에서 늘릴 수 있습니다.',
    errorFriendYourself: '자기 자신은 친구로 등록할 수 없습니다 (;ㅅ;)',
    errorAlreadyFriend: '이 유저는 이미 당신의 친구입니다',
    errorDoesNotExist: '존재하지 않는 계정입니다',
    errorFriendLimit: '더 이상 친구를 늘릴 수 없습니다',
  },
  subscription: {
    subscription: '구독 플랜',
    subscribe: '구독하기',
    autoRenew: '자동 갱신',
    renewalInfo: '자동 갱신을 활성화하면, 충분한 메모리가 있는 한 30일마다 자동으로 구독이 갱신됩니다.',
    benefitHeader: '구독 혜택',
    spendMemories: '<b>200</b> 메모리를 사용해 30일간 구독을 활성화하시겠습니까?',
    confirmPurchase: '결제 확인',
    notEnoughMemories: '메모리가 부족합니다',
    memoriesRequired: '{amount}%@ 메모리가 필요합니다',
    redirectToMemory: '메모리 구매 페이지로 이동해 메모리를 충전하시겠습니까?',
    confirmCancel: '정말로 구독을 취소하시겠습니까?',
    cancelDisclaimer: '구독을 취소해도 혜택이 바로 사라지진 않습니다. 남은 구독 기간동안 여전히 혜택을 누릴 수 있습니다.',
    keepSubscription: '구독 유지하기',
    cancelSubscription: '구독 취소',
    paymentComplete: '구독 완료',
    paymentCompleteMessage: 'Arcaea Online을 구독해주셔서 감사합니다!',
    required: '구독이 필요한 기능입니다',
    requiredText: '이 페이지에 액세스하려면 Arcaea Online을 구독해주세요.',
    goToSubscribe: '구독하기',
    yourSubscription: '구독 상황',
    renewMessage: '{arcaeaOnlineExpiredDate}에 구독이 자동 갱신됩니다.',
    reactivate: '다시 구독하기',
    success: '구독 완료',
    successMessage: 'Arcaea Online을 구독해주셔서 감사합니다!',
    cancelled: '구독 취소',
    cancelledMessage: '	Arcaea Online 구독이 취소되었습니다. 구독 혜택은 {arcaeaOnlineExpiredDate}까지 여전히 누리실 수 있습니다.'
  },
  clearType: {
    clear: 'CLEAR',
    fr: 'FULL RECALL',
    pm: 'PURE MEMORY',
  },
  sort: {
    by: '정렬',
    name: '이름순',
    level: '레벨순',
    date: '날짜순',
    score: '점수순',
    title: '곡명순',
    scoreBelowMax: '이론치 미만'
  },
  partner: {
    level: '레벨',
    currentPartner: '현재 파트너',
    selected: '선택중'
  },
  characterType: {
    0: 'BALANCE',
    1: 'SUPPORT',
    2: 'CHALLENGE',
    3: 'CREATOR',
  },
  profile: {
    scenerySelectTitle: '배경 선택',
    sceneryUnlockInGame: '배경은 월드 모드에서 해금할 수 있습니다.'
  },
  worldUnlock: {
    locked: '월드 모드에서 해금 가능<br/>(챕터 {index})',
    beginning: '이야기의 시작',
    lockedchap1: '챕터 1',
    lockedchap2: '챕터 2',
    lockedchap3: '챕터 3',
    lockedchap4: '챕터 4',
    lockedchap5: '챕터 5',
    lockedchap6: '챕터 6',
    lockedchap7: '챕터 7',
    lockedbeyond: 'Lost Chapter: Beyond',
    unlockedchap1 : '잃어버린 세계',
    unlockedchap2 : '외부 도달',
    unlockedchap3 : '첨탑의 수렴점',
    unlockedchap4 : '잠들어 버린 메아리',
    unlockedchap5 : '이겨낼 수 없는 분열',
    unlockedchap6 : '포가튼 콘스트럭트',
    unlockedchap7 : '회상의 지평선',
    unlockedbeyond: 'Lost Chapter: Beyond',
  },
  sidebar: {
    profile: '프로필',
    friends: '친구',
    partners: '파트너',
    leaderboards: '리더보드',
    scoreData: '스코어 데이터',
    potential: 'Potential',
    memoriesAndSubscription: '메모리 & 구독',
    accountAndSettings: '계정 & 설정',
  },
  goods: {
    originalSoundtracks: '오리지널 사운드 트랙',
    diverseDirect: 'DIVERSE DIRECT',
    tanoc: 'TANO*C STORE',
    amazon: 'Amazon.co.jp',
    lineHeader: '아르케아 공식 라인 스티커',
    lineText1: '아르케아 공식 스티커의 귀엽고 다채로운 캐릭터들로 보다 더 기억에 오래 남을 대화를 만들어 보세요!',
    lineButton: 'LINE Store에서 확인하기'
  },
  digitalContents: {
    ostHeader: '오리지널 사운드트랙',
    generateDownloadLink: '다운로드 링크 생성',
    redeemOST: '오리지널 사운드트랙 수령하기',
    redeemOSTDescription: '오리지널 사운드트랙 케이스 안에 동봉된 코드가 적힌 종이를 찾아주세요. <b>Arcaea</b> 앱을 열어 <b>Network</b> 버튼을 누른 후, <b>리딤코드 사용하기</b>를 선택하세요.',
    downloadRemaining: '{amount} 다운로드 남음',
    downloadsRemaining: '{amount} 다운로드 남음',
    notOwned: '소유하지 않음'
  },
  songRanking: {
    freeMusic: '무료곡',
    paidMusic: '유료곡',
    title: '곡 제목',
    artist: '작곡가',
    new: '신곡'
  },
  verify: {
    verifyAccount: '계정 인증',
    enterEmail: '등록된 이메일을 입력해주세요',
    verify: '인증하기',
    verifySuccess: '계정 인증을 성공적으로 완료하였습니다.',
    verifyError: '계정 인증 도중 에러가 발생했습니다.',
    clickHere: '고객 지원',
    verifySupport: '{0}으로 연락해주시길 바랍니다.',
    errorInvalidEmail: '이메일 주소가 유효한지 확인해주세요',
    errorInvalidToken: '등록 기한이 만료되었거나, URL 주소가 무효하여 등록을 완료하지 못했습니다. 이메일을 확인하거나 새 계정을 등록해주세요.',
    errorExpiredToken: '등록 기한이 만료되었습니다. 새 계정을 등록해주세요.',
    errorCaptchaFailed: 'CAPTCHA 인증에 실패했습니다. 다시 시도해주세요.',
  },
  purchase: {
    sorryNotSupported: '죄송합니다. 이 지역에서의 구매는 현재 Arcaea 웹사이트에서 제공되지 않습니다.',
    memoryWithBonus: '{amount} + 보너스 ({bonusAmount})',
    priceCurrencyFront: '{currency}{amount}',
    priceCurrencyBack: '{amount}{currency}'
  },
  story: {
    slide1: {
      text: `두 어린 소녀는 소음이 가득한 부서진 세상 속에서 밝혀야 할 과거를 향해 모험한다...<br/>
<br/>
이 허무한 공간, 그녀의 존재가 비어버린 것 같은, 세상의 파멸 그 순간의 발견, 아무것도 기억할 수 없는 이전까지의 모습.<br/>
그리고선 이어지는 두번째 발견, 그것은 과거의 생생한 기억들을 머금고 있는 깨져버린 유리 파편처럼 생긴 수많은 조각들, 아르케아.<br/>`,
    },
    slide2: {
      text: `조각들은 마치 스스로 선택하듯 두 소녀들을 향해 모여들었고, 둘은 각자의 방식대로 서로 다른 과거의 경험을 하게 된다.<br/>
<br/>
<i>유리 조각은 지금 소녀가 있는 이 새하얀 세계가 아닌 다른 세계의 모습을 비추고 있었다. 바다, 도시, 화염, 불빛이 차례대로 보였다. 소녀는 손을 뻗어 조각들을 흐트러뜨리며 즐겁게 웃었다.
</i><br/>
<br/>
<i>조각은 시시각각 다른 풍경을 보여주고 있었다. 마치 달리는 기차의 창문으로 보는 바깥 풍경과 같았다. 한순간은 비, 또 다른 순간은 햇살, 그리고 죽음… 소녀는 얼굴을 찡그리며 물러났다. </i>.<br/>
      `
    },
    slide3: {
      text: `부숴진 세상을 탐험하며 과거를 밝히는 두 어린 소녀.<br/>
<br/>
하나는 빛, 그리고 다른 하나는 대립.<br/>
<br/>
아르케아 세상에서의 탐험은 과연 이 둘을 어떻게 바꿔놓게 될 것인가?<br/>
<br/>
<i>이 단순하고 행복한 세계는 계속해서 단순하고 행복하게 있기만 하면 된다. 다만 그뿐이다.</i><br/>
<br/>
<i>이 조각들이 비추는 장소가 어딘지는 모르겠지만, 조그마한 불빛이 잠시 나타났다 사라질 뿐인, 빛이 없는 풍경이었다.</i><br/>
<br/>
그리고 둘의 여정이 끝날 때 즘에, 두 소녀는 무엇이 되어 있을 것인가?
`,
    }
  },
  links: {
    twitter: 'https://twitter.com/arcaea_kr'
  },
  fbLang: 'ko_KR',
  countries: [
    { "id": 288, "name": "가나", "a2": "gh" },
    { "id": 266, "name": "가봉", "a2": "ga" },
    { "id": 328, "name": "가이아나", "a2": "gy" },
    { "id": 270, "name": "감비아", "a2": "gm" },
    { "id": 831, "name": "건지섬", "a2": "gg" },
    { "id": 312, "name": "과들루프", "a2": "gp" },
    { "id": 320, "name": "과테말라", "a2": "gt" },
    { "id": 316, "name": "괌", "a2": "gu" },
    { "id": 308, "name": "그레나다", "a2": "gd" },
    { "id": 300, "name": "그리스", "a2": "gr" },
    { "id": 304, "name": "그린란드", "a2": "gl" },
    { "id": 324, "name": "기니", "a2": "gn" },
    { "id": 624, "name": "기니비사우", "a2": "gw" },
    { "id": 516, "name": "나미비아", "a2": "na" },
    { "id": 520, "name": "나우루", "a2": "nr" },
    { "id": 566, "name": "나이지리아", "a2": "ng" },
    { "id": 10, "name": "남극", "a2": "aq" },
    { "id": 728, "name": "남수단", "a2": "ss" },
    { "id": 710, "name": "남아프리카 공화국", "a2": "za" },
    { "id": 528, "name": "네덜란드", "a2": "nl" },
    { "id": 524, "name": "네팔", "a2": "np" },
    { "id": 578, "name": "노르웨이", "a2": "no" },
    { "id": 574, "name": "노퍽섬", "a2": "nf" },
    { "id": 540, "name": "누벨칼레도니", "a2": "nc" },
    { "id": 554, "name": "뉴질랜드", "a2": "nz" },
    { "id": 570, "name": "니우에", "a2": "nu" },
    { "id": 562, "name": "니제르", "a2": "ne" },
    { "id": 558, "name": "니카라과", "a2": "ni" },
    { "id": 410, "name": "대한민국", "a2": "kr" },
    { "id": 208, "name": "덴마크", "a2": "dk" },
    { "id": 214, "name": "도미니카 공화국", "a2": "do" },
    { "id": 212, "name": "도미니카 연방", "a2": "dm" },
    { "id": 276, "name": "독일", "a2": "de" },
    { "id": 626, "name": "동티모르", "a2": "tl" },
    { "id": 418, "name": "라오스", "a2": "la" },
    { "id": 430, "name": "라이베리아", "a2": "lr" },
    { "id": 428, "name": "라트비아", "a2": "lv" },
    { "id": 643, "name": "러시아", "a2": "ru" },
    { "id": 422, "name": "레바논", "a2": "lb" },
    { "id": 426, "name": "레소토", "a2": "ls" },
    { "id": 638, "name": "레위니옹", "a2": "re" },
    { "id": 642, "name": "루마니아", "a2": "ro" },
    { "id": 442, "name": "룩셈부르크", "a2": "lu" },
    { "id": 646, "name": "르완다", "a2": "rw" },
    { "id": 434, "name": "리비아", "a2": "ly" },
    { "id": 440, "name": "리투아니아", "a2": "lt" },
    { "id": 438, "name": "리히텐슈타인", "a2": "li" },
    { "id": 450, "name": "마다가스카르", "a2": "mg" },
    { "id": 474, "name": "마르티니크", "a2": "mq" },
    { "id": 584, "name": "마셜 제도", "a2": "mh" },
    { "id": 175, "name": "마요트", "a2": "yt" },
    { "id": 446, "name": "마카오", "a2": "mo" },
    { "id": 807, "name": "북마케도니아", "a2": "mk" },
    { "id": 454, "name": "말라위", "a2": "mw" },
    { "id": 458, "name": "말레이시아", "a2": "my" },
    { "id": 466, "name": "말리", "a2": "ml" },
    { "id": 833, "name": "맨섬", "a2": "im" },
    { "id": 484, "name": "멕시코", "a2": "mx" },
    { "id": 492, "name": "모나코", "a2": "mc" },
    { "id": 504, "name": "모로코", "a2": "ma" },
    { "id": 480, "name": "모리셔스", "a2": "mu" },
    { "id": 478, "name": "모리타니", "a2": "mr" },
    { "id": 508, "name": "모잠비크", "a2": "mz" },
    { "id": 499, "name": "몬테네그로", "a2": "me" },
    { "id": 500, "name": "몬트세랫", "a2": "ms" },
    { "id": 498, "name": "몰도바", "a2": "md" },
    { "id": 462, "name": "몰디브", "a2": "mv" },
    { "id": 470, "name": "몰타", "a2": "mt" },
    { "id": 496, "name": "몽골", "a2": "mn" },
    { "id": 840, "name": "미국", "a2": "us" },
    { "id": 581, "name": "미국령 군소 제도", "a2": "um" },
    { "id": 850, "name": "미국령 버진아일랜드", "a2": "vi" },
    { "id": 104, "name": "미얀마", "a2": "mm" },
    { "id": 583, "name": "미크로네시아 연방", "a2": "fm" },
    { "id": 548, "name": "바누아투", "a2": "vu" },
    { "id": 48, "name": "바레인", "a2": "bh" },
    { "id": 52, "name": "바베이도스", "a2": "bb" },
    { "id": 336, "name": "바티칸 시국", "a2": "va" },
    { "id": 44, "name": "바하마", "a2": "bs" },
    { "id": 50, "name": "방글라데시", "a2": "bd" },
    { "id": 60, "name": "버뮤다", "a2": "bm" },
    { "id": 204, "name": "베냉", "a2": "bj" },
    { "id": 862, "name": "베네수엘라", "a2": "ve" },
    { "id": 704, "name": "베트남", "a2": "vn" },
    { "id": 56, "name": "벨기에", "a2": "be" },
    { "id": 112, "name": "벨라루스", "a2": "by" },
    { "id": 84, "name": "벨리즈", "a2": "bz" },
    { "id": 535, "name": "보네르섬", "a2": "bq" },
    { "id": 70, "name": "보스니아 헤르체고비나", "a2": "ba" },
    { "id": 72, "name": "보츠와나", "a2": "bw" },
    { "id": 68, "name": "볼리비아", "a2": "bo" },
    { "id": 108, "name": "부룬디", "a2": "bi" },
    { "id": 854, "name": "부르키나파소", "a2": "bf" },
    { "id": 74, "name": "부베섬", "a2": "bv" },
    { "id": 64, "name": "부탄", "a2": "bt" },
    { "id": 580, "name": "북마리아나 제도", "a2": "mp" },
    { "id": 100, "name": "불가리아", "a2": "bg" },
    { "id": 76, "name": "브라질", "a2": "br" },
    { "id": 96, "name": "브루나이", "a2": "bn" },
    { "id": 882, "name": "사모아", "a2": "ws" },
    { "id": 682, "name": "사우디아라비아", "a2": "sa" },
    { "id": 239, "name": "사우스조지아 사우스샌드위치 제도", "a2": "gs" },
    { "id": 674, "name": "산마리노", "a2": "sm" },
    { "id": 678, "name": "상투메 프린시페", "a2": "st" },
    { "id": 663, "name": "생마르탱", "a2": "mf" },
    { "id": 652, "name": "생바르텔레미", "a2": "bl" },
    { "id": 666, "name": "생피에르 미클롱", "a2": "pm" },
    { "id": 732, "name": "서사하라", "a2": "eh" },
    { "id": 686, "name": "세네갈", "a2": "sn" },
    { "id": 688, "name": "세르비아", "a2": "rs" },
    { "id": 690, "name": "세이셸", "a2": "sc" },
    { "id": 662, "name": "세인트루시아", "a2": "lc" },
    { "id": 670, "name": "세인트빈센트 그레나딘", "a2": "vc" },
    { "id": 659, "name": "세인트키츠 네비스", "a2": "kn" },
    { "id": 654, "name": "세인트헬레나", "a2": "sh" },
    { "id": 706, "name": "소말리아", "a2": "so" },
    { "id": 90, "name": "솔로몬 제도", "a2": "sb" },
    { "id": 729, "name": "수단", "a2": "sd" },
    { "id": 740, "name": "수리남", "a2": "sr" },
    { "id": 144, "name": "스리랑카", "a2": "lk" },
    { "id": 744, "name": "스발바르 얀마옌", "a2": "sj" },
    { "id": 752, "name": "스웨덴", "a2": "se" },
    { "id": 756, "name": "스위스", "a2": "ch" },
    { "id": 724, "name": "스페인", "a2": "es" },
    { "id": 703, "name": "슬로바키아", "a2": "sk" },
    { "id": 705, "name": "슬로베니아", "a2": "si" },
    { "id": 760, "name": "시리아", "a2": "sy" },
    { "id": 694, "name": "시에라리온", "a2": "sl" },
    { "id": 534, "name": "신트마르턴", "a2": "sx" },
    { "id": 702, "name": "싱가포르", "a2": "sg" },
    { "id": 784, "name": "아랍에미리트", "a2": "ae" },
    { "id": 533, "name": "아루바", "a2": "aw" },
    { "id": 51, "name": "아르메니아", "a2": "am" },
    { "id": 32, "name": "아르헨티나", "a2": "ar" },
    { "id": 16, "name": "아메리칸사모아", "a2": "as" },
    { "id": 352, "name": "아이슬란드", "a2": "is" },
    { "id": 332, "name": "아이티", "a2": "ht" },
    { "id": 372, "name": "아일랜드", "a2": "ie" },
    { "id": 31, "name": "아제르바이잔", "a2": "az" },
    { "id": 4, "name": "아프가니스탄", "a2": "af" },
    { "id": 20, "name": "안도라", "a2": "ad" },
    { "id": 8, "name": "알바니아", "a2": "al" },
    { "id": 12, "name": "알제리", "a2": "dz" },
    { "id": 24, "name": "앙골라", "a2": "ao" },
    { "id": 28, "name": "앤티가 바부다", "a2": "ag" },
    { "id": 660, "name": "앵귈라", "a2": "ai" },
    { "id": 232, "name": "에리트레아", "a2": "er" },
    { "id": 748, "name": "에스와티니", "a2": "sz" },
    { "id": 233, "name": "에스토니아", "a2": "ee" },
    { "id": 218, "name": "에콰도르", "a2": "ec" },
    { "id": 231, "name": "에티오피아", "a2": "et" },
    { "id": 222, "name": "엘살바도르", "a2": "sv" },
    { "id": 826, "name": "영국", "a2": "gb" },
    { "id": 92, "name": "영국령 버진아일랜드", "a2": "vg" },
    { "id": 86, "name": "영국령 인도양 지역", "a2": "io" },
    { "id": 887, "name": "예멘", "a2": "ye" },
    { "id": 512, "name": "오만", "a2": "om" },
    { "id": 36, "name": "오스트레일리아", "a2": "au" },
    { "id": 40, "name": "오스트리아", "a2": "at" },
    { "id": 340, "name": "온두라스", "a2": "hn" },
    { "id": 248, "name": "올란드 제도", "a2": "ax" },
    { "id": 400, "name": "요르단", "a2": "jo" },
    { "id": 800, "name": "우간다", "a2": "ug" },
    { "id": 858, "name": "우루과이", "a2": "uy" },
    { "id": 860, "name": "우즈베키스탄", "a2": "uz" },
    { "id": 804, "name": "우크라이나", "a2": "ua" },
    { "id": 876, "name": "왈리스 푸투나", "a2": "wf" },
    { "id": 368, "name": "이라크", "a2": "iq" },
    { "id": 364, "name": "이란", "a2": "ir" },
    { "id": 376, "name": "이스라엘", "a2": "il" },
    { "id": 818, "name": "이집트", "a2": "eg" },
    { "id": 380, "name": "이탈리아", "a2": "it" },
    { "id": 356, "name": "인도", "a2": "in" },
    { "id": 360, "name": "인도네시아", "a2": "id" },
    { "id": 392, "name": "일본", "a2": "jp" },
    { "id": 388, "name": "자메이카", "a2": "jm" },
    { "id": 894, "name": "잠비아", "a2": "zm" },
    { "id": 832, "name": "저지섬", "a2": "je" },
    { "id": 226, "name": "적도 기니", "a2": "gq" },
    { "id": 408, "name": "조선민주주의인민공화국", "a2": "kp" },
    { "id": 268, "name": "조지아", "a2": "ge" },
    { "id": 156, "name": "중국 본토", "a2": "cn" },
    { "id": 140, "name": "중앙아프리카 공화국", "a2": "cf" },
    { "id": 262, "name": "지부티", "a2": "dj" },
    { "id": 292, "name": "지브롤터", "a2": "gi" },
    { "id": 716, "name": "짐바브웨", "a2": "zw" },
    { "id": 148, "name": "차드", "a2": "td" },
    { "id": 203, "name": "체코", "a2": "cz" },
    { "id": 152, "name": "칠레", "a2": "cl" },
    { "id": 120, "name": "카메룬", "a2": "cm" },
    { "id": 132, "name": "카보베르데", "a2": "cv" },
    { "id": 398, "name": "카자흐스탄", "a2": "kz" },
    { "id": 634, "name": "카타르", "a2": "qa" },
    { "id": 116, "name": "캄보디아", "a2": "kh" },
    { "id": 124, "name": "캐나다", "a2": "ca" },
    { "id": 404, "name": "케냐", "a2": "ke" },
    { "id": 136, "name": "케이맨 제도", "a2": "ky" },
    { "id": 174, "name": "코모로", "a2": "km" },
    { "id": 188, "name": "코스타리카", "a2": "cr" },
    { "id": 166, "name": "코코스 제도", "a2": "cc" },
    { "id": 384, "name": "코트디부아르", "a2": "ci" },
    { "id": 170, "name": "콜롬비아", "a2": "co" },
    { "id": 178, "name": "콩고 공화국", "a2": "cg" },
    { "id": 180, "name": "콩고 민주 공화국", "a2": "cd" },
    { "id": 192, "name": "쿠바", "a2": "cu" },
    { "id": 414, "name": "쿠웨이트", "a2": "kw" },
    { "id": 184, "name": "쿡 제도", "a2": "ck" },
    { "id": 531, "name": "퀴라소", "a2": "cw" },
    { "id": 191, "name": "크로아티아", "a2": "hr" },
    { "id": 162, "name": "크리스마스섬", "a2": "cx" },
    { "id": 417, "name": "키르기스스탄", "a2": "kg" },
    { "id": 296, "name": "키리바시", "a2": "ki" },
    { "id": 196, "name": "키프로스", "a2": "cy" },
    { "id": 158, "name": "타이완", "a2": "tw" },
    { "id": 762, "name": "타지키스탄", "a2": "tj" },
    { "id": 834, "name": "탄자니아", "a2": "tz" },
    { "id": 764, "name": "태국", "a2": "th" },
    { "id": 796, "name": "터크스 케이커스 제도", "a2": "tc" },
    { "id": 792, "name": "터키", "a2": "tr" },
    { "id": 768, "name": "토고", "a2": "tg" },
    { "id": 772, "name": "토켈라우", "a2": "tk" },
    { "id": 776, "name": "통가", "a2": "to" },
    { "id": 795, "name": "투르크메니스탄", "a2": "tm" },
    { "id": 798, "name": "투발루", "a2": "tv" },
    { "id": 788, "name": "튀니지", "a2": "tn" },
    { "id": 780, "name": "트리니다드 토바고", "a2": "tt" },
    { "id": 591, "name": "파나마", "a2": "pa" },
    { "id": 600, "name": "파라과이", "a2": "py" },
    { "id": 586, "name": "파키스탄", "a2": "pk" },
    { "id": 598, "name": "파푸아뉴기니", "a2": "pg" },
    { "id": 585, "name": "팔라우", "a2": "pw" },
    { "id": 275, "name": "팔레스타인", "a2": "ps" },
    { "id": 234, "name": "페로 제도", "a2": "fo" },
    { "id": 604, "name": "페루", "a2": "pe" },
    { "id": 620, "name": "포르투갈", "a2": "pt" },
    { "id": 238, "name": "포클랜드 제도", "a2": "fk" },
    { "id": 616, "name": "폴란드", "a2": "pl" },
    { "id": 630, "name": "푸에르토리코", "a2": "pr" },
    { "id": 250, "name": "프랑스", "a2": "fr" },
    { "id": 254, "name": "프랑스령 기아나", "a2": "gf" },
    { "id": 260, "name": "프랑스령 남방 및 남극 지역", "a2": "tf" },
    { "id": 258, "name": "프랑스령 폴리네시아", "a2": "pf" },
    { "id": 242, "name": "피지", "a2": "fj" },
    { "id": 246, "name": "핀란드", "a2": "fi" },
    { "id": 608, "name": "필리핀", "a2": "ph" },
    { "id": 612, "name": "핏케언 제도", "a2": "pn" },
    { "id": 334, "name": "허드 맥도널드 제도", "a2": "hm" },
    { "id": 348, "name": "헝가리", "a2": "hu" },
    { "id": 344, "name": "홍콩", "a2": "hk" }
  ]
}